import { Divider, Stack } from '@mantine/core';
import { DataInput } from '@/types/automationFields.ts';
import { TransformDataStep } from '@/types/automationSteps.ts';
import { useUpdateStepFields } from '@/hooks/api/steps/useUpdateStepFields.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import MultiDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/MultiDataInputSelector/MultiDataInputSelector.tsx';
import TransformDataFields from '@/pages/Editor/components/StepSidebar/StepForms/TransformDataStep/TransformDataFields.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';
import TransformDataOutputFields from '@/pages/Editor/components/StepSidebar/StepForms/TransformDataStep/TransformDataOutputFields.tsx';

type props = {
  step: TransformDataStep;
  hasParentStep?: boolean;
};

type Fields = {
  data_inputs: DataInput[];
};

export function TransformDataForm({ step, hasParentStep = false }: props) {
  const { fields, onChangeNoDelay } = useUpdateStepFields<Fields>({ step });
  const dataInputs = fields.data_inputs ?? [];
  const updateDataInputs = (nextDataInputs: DataInput[]) =>
    onChangeNoDelay({ data_inputs: nextDataInputs });

  return (
    <Stack gap={'md'}>
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <Divider mt="xs" mb={'0'} />
      <MultiDataInputSelector
        step={step}
        dataInputs={dataInputs}
        onDataInputsChange={updateDataInputs}
      />
      <Divider mt="xs" mb={'0'} />
      <TransformDataFields
        step={step}
        dataInputs={dataInputs}
        updateDataInputs={updateDataInputs}
        hasParentStep={hasParentStep}
      />
      <Divider mt="xs" mb={'0'} />
      <TransformDataOutputFields step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
